import "core-js/modules/es.symbol";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doInitializeLeadForm),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doSubmitLeadForm),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(watchLeadFormSagas);

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { defineMessages } from 'react-intl';
import { initialize, SubmissionError } from 'redux-form';
import { createFormAction } from 'redux-form-saga';
import { call, fork, put, select, spawn, takeEvery } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { deepExtract } from 'helpers/deep';
import * as ObjectUtil from 'helpers/object';
import { ga } from 'helpers/multitrack';
import { set as setUserType } from 'helpers/userTypeCookie';
import { selectUserLocale } from 'redux/modules/locale';
import { getUserLocation } from 'redux/saga/helpers';
import { loadAccountCreationConsent } from 'components/Consent/Consent.saga';
import { GENERIC_ERROR } from 'components/Errors/ApiError';
import { CODE_BY_ERROR, createLead } from 'features/LeadGenForm/LeadGenForm.saga';
var messages = defineMessages({
  alreadyMember: {
    id: 'signup.lead.already-member',
    defaultMessage: 'Looks like you already started creating a ClassPass account with this email address in the past. Please <a href="{loginLink}">log in</a> to complete your purchase.',
    hasHtml: true
  },
  invalidEmail: {
    id: 'signup.lead.invalid-email',
    defaultMessage: 'Please check your email address for misspellings.'
  }
});
export var LEAD_FORM = 'signup-card-lead';
export var leadFormAction = createFormAction(LEAD_FORM);
export var initializeLeadForm = function initializeLeadForm(hiddenFields) {
  return {
    type: "INITIALIZE_".concat(LEAD_FORM),
    hiddenFields: hiddenFields
  };
};
export function doInitializeLeadForm(client, _ref) {
  var hiddenFields, consent;
  return regeneratorRuntime.wrap(function doInitializeLeadForm$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          hiddenFields = _ref.hiddenFields;
          _context.next = 3;
          return call(loadAccountCreationConsent, client);

        case 3:
          consent = _context.sent;
          _context.next = 6;
          return put(initialize(LEAD_FORM, _objectSpread({}, ObjectUtil.pick(['marketing', 'marketingDisclaimer', 'marketingDefault'], consent), hiddenFields)));

        case 6:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doSubmitLeadForm(client, _ref2) {
  var form, locale, activeLocation, errorCode, emailError, generalError, loginLink;
  return regeneratorRuntime.wrap(function doSubmitLeadForm$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          form = _ref2.payload;

          if (!form.marketing) {
            _context2.next = 46;
            break;
          }

          _context2.prev = 2;
          _context2.next = 5;
          return select(selectUserLocale);

        case 5:
          locale = _context2.sent;
          _context2.next = 8;
          return call(getUserLocation, client);

        case 8:
          activeLocation = _context2.sent;
          _context2.next = 11;
          return call(createLead, client, form.email, {
            locale: locale,
            location: activeLocation
          });

        case 11:
          _context2.next = 13;
          return call(ga, 'Membership Purchase', 'Membership Purchase Lead Creation');

        case 13:
          _context2.next = 46;
          break;

        case 15:
          _context2.prev = 15;
          _context2.t0 = _context2["catch"](2);
          errorCode = deepExtract('code', _context2.t0);

          if (!(CODE_BY_ERROR.ALREADY_ON_WAITLIST === errorCode)) {
            _context2.next = 23;
            break;
          }

          _context2.next = 21;
          return call(setUserType, 'lead');

        case 21:
          _context2.next = 46;
          break;

        case 23:
          if (!(CODE_BY_ERROR.ALREADY_MEMBER === errorCode)) {
            _context2.next = 32;
            break;
          }

          _context2.next = 26;
          return call(setUserType, 'registered');

        case 26:
          loginLink = "/login?returnTo=".concat(form.resumeSignupLink);
          emailError = _objectSpread({}, messages.alreadyMember, {
            values: {
              loginLink: loginLink
            }
          });
          _context2.next = 30;
          return call(ga, 'Membership Purchase', 'Membership Purchase Lead Creation Error', 'Already member');

        case 30:
          _context2.next = 43;
          break;

        case 32:
          if (!(CODE_BY_ERROR.INVALID_EMAIL === errorCode)) {
            _context2.next = 38;
            break;
          }

          emailError = messages.invalidEmail;
          _context2.next = 36;
          return call(ga, 'Membership Purchase', 'Membership Purchase Lead Creation Error', 'Invalid email');

        case 36:
          _context2.next = 43;
          break;

        case 38:
          generalError = GENERIC_ERROR;
          _context2.next = 41;
          return call(ga, 'Membership Purchase', 'Membership Purchase Lead Creation Error', 'Unexpected error');

        case 41:
          _context2.next = 43;
          return spawn(logger.error, 'Failed to create lead during signup', _context2.t0);

        case 43:
          _context2.next = 45;
          return put(leadFormAction.failure(new SubmissionError({
            _error: generalError,
            email: emailError
          })));

        case 45:
          return _context2.abrupt("return", _context2.sent);

        case 46:
          _context2.next = 48;
          return put(leadFormAction.success(ObjectUtil.pick(['email', 'marketing', 'marketingDisclaimer', 'marketingDefault'], form)));

        case 48:
          return _context2.abrupt("return", _context2.sent);

        case 49:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[2, 15]]);
}
export function watchLeadFormSagas(client) {
  return regeneratorRuntime.wrap(function watchLeadFormSagas$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return fork(takeEvery, initializeLeadForm().type, doInitializeLeadForm, client);

        case 2:
          _context3.next = 4;
          return fork(takeEvery, leadFormAction.REQUEST, doSubmitLeadForm, client);

        case 4:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3);
}